import Swiper from 'swiper';
import { EffectFade, Autoplay } from 'swiper/modules';

export function initHeroSliders() {
    document.querySelectorAll('.heroSlider:not([data-hero-init])').forEach(section => {
        section.setAttribute('data-hero-init', '1');

        const swiperEl = section.querySelector('.heroSlider__swiper');
        const navEl = section.querySelector('.heroSlider__navigation');
        const contentWrapper = section.querySelector('.heroSlider__contentWrapper');
        const contents = contentWrapper ? Array.from(contentWrapper.querySelectorAll('.heroSlider__content')) : [];

        const swiper = new Swiper(swiperEl, {
            modules: [EffectFade, Autoplay],
            autoplay: { delay: 5000, disableOnInteraction: false },
            effect: 'fade',
            fadeEffect: { crossFade: true },
            loop: false,
            speed: 700,
            allowTouchMove: true,
            grabCursor: true,
        });

        Array.from(swiperEl.querySelectorAll('.swiper-slide')).forEach((slide, i) => {
            slide.querySelectorAll('.heroSlider__img img').forEach(img => {
                if (i === 0) {
                    img.setAttribute('fetchpriority', 'high');
                    img.setAttribute('loading', 'eager');
                } else {
                    img.setAttribute('loading', 'lazy');
                }
            });
        });

        if (contents[0]) {
            contents[0].classList.add('is-active');
        }

        for (let i = 0; i < swiper.slides.length; i++) {
            const btn = document.createElement('button');
            btn.className = 'heroSlider__navBtn' + (i === 0 ? ' is-active' : '');
            btn.setAttribute('aria-label', `Slide ${i + 1}`);
            btn.textContent = String(i + 1).padStart(2, '0');
            btn.addEventListener('click', () => swiper.slideTo(i));
            navEl.appendChild(btn);
        }

        const navBtns = navEl.querySelectorAll('.heroSlider__navBtn');

        swiper.on('slideChange', () => {
            navBtns.forEach((btn, i) => {
                btn.classList.toggle('is-active', i === swiper.realIndex);
            });

            contents.forEach(c => c.classList.remove('is-active'));

            const next = contents[swiper.realIndex];
            if (next) {
                next.classList.add('is-active');
            }
        });
    });
}